/**
 * FileService
 *
 * Service used to construct and export/download files and reports
 *
 *
 */

import fs from "@/services/FormatService";
import moment from "moment";
import _ from "lodash";

export default {
	// exportProfileReport(section, program, assignments, profiles) {
	// 	let filenameFields = [section.name, "Top Strengths"];

	// 	let borderStyle = {
	// 		left: {
	// 			style: "thin",
	// 			color: '#000000'
	// 		},
	// 		right: {
	// 			style: "thin",
	// 			color: '#000000'
	// 		},
	// 		top: {
	// 			style: "thin",
	// 			color: '#000000'
	// 		},
	// 		bottom: {
	// 			style: "thin",
	// 			color: '#000000'
	// 		},
	// 	}

	// 	let yAxisStyle = {
	// 		alignment: {
	// 			wrapText: true,
	// 			vertical: "center",
	// 		},
	// 		border: borderStyle,
	// 		font: {
	// 			name: 'Century Schoolbook',
	// 			size: 13,
	// 			bold: true,
	// 		}
	// 	}

	// 	let headers = ["Skills & Mindsets"];
	// 	let header_styles = [yAxisStyle];
	// 	let sortedStrengths = [];

	// 	let catHeading = []
	// 	catHeading.push({ "cells": [1, 1, 1, 1], "content": "", style: yAxisStyle })
	// 	catHeading.push({ "cells": [2, 1, 2, 1], "content": "Leadership Descriptions", style: yAxisStyle })

	// 	let categories = program.profile_config.categories.concat({ "id": "", "color": "#FFFFFF" })

	// 	let currentCol = 2;
	// 	_.each(categories, (cat) => {
	// 		let strengths = program.profile_config.strengths.filter(strength => strength.category_id == cat.id)
	// 		if (cat.name) {
	// 			catHeading.push({
	// 				"cells": [1, currentCol, 1, currentCol + strengths.length - 1], "content": cat.name, "style": {
	// 					alignment: {
	// 						wrapText: true,
	// 						vertical: "center",
	// 						horizontal: "center",
	// 					},
	// 					border: borderStyle,
	// 					font: {
	// 						name: 'Helvetica',
	// 						size: 25,
	// 					},
	// 					fill: {
	// 						type: "pattern",
	// 						patternType: "solid",
	// 						bgColor: this.dimColor(cat.color, 1),
	// 						fgColor: this.dimColor(cat.color, 1),
	// 					}
	// 				}
	// 			});
	// 		}
	// 		if (cat.desc) {
	// 			catHeading.push({
	// 				"cells": [2, currentCol, 2, currentCol + strengths.length - 1], "content": cat.desc, "style": {
	// 					alignment: {
	// 						wrapText: true,
	// 						vertical: "center",
	// 						horizontal: "center",
	// 					},
	// 					border: borderStyle,
	// 					font: {
	// 						name: 'Century Schoolbook',
	// 						size: 11,
	// 						bold: true,
	// 					},
	// 					fill: {
	// 						type: "pattern",
	// 						patternType: "solid",
	// 						bgColor: this.dimColor(cat.color, 1),
	// 						fgColor: this.dimColor(cat.color, 1),
	// 					}
	// 				}
	// 			});
	// 		}

	// 		for (let i = 0; i < strengths.length; i++) {
	// 			headers.push([
	// 				{ name: 'Century Schoolbook', size: 15, bold: true },
	// 				strengths[i].name + '\n',
	// 				{ name: 'Century Schoolbook', size: 10, bold: false },
	// 				strengths[i].subtitle
	// 			])
	// 			header_styles.push({
	// 				alignment: {
	// 					wrapText: true,
	// 					vertical: "center",
	// 					horizontal: "center",
	// 					textRotation: 90,
	// 				},
	// 				border: borderStyle,
	// 				fill: {
	// 					type: "pattern",
	// 					patternType: "solid",
	// 					bgColor: this.dimColor(cat.color, i),
	// 					fgColor: this.dimColor(cat.color, i),
	// 				}
	// 			});
	// 			sortedStrengths.push(strengths[i])
	// 		}
	// 		currentCol = currentCol + strengths.length;
	// 	});

	// 	let tables = [];

	// 	_.each(assignments, (a) => {
	// 		let table = { "heading": catHeading, "name": a.name, rows: [headers], styles: [header_styles] }
	// 		let ordered_profiles = _.orderBy(profiles, "user.name.last").filter(p => p.assignment_id == a.id)
	// 		_.each(ordered_profiles, (p) => {
	// 			let row = [fs.displayNameReverse(p.user.name)];
	// 			let row_styles = [{
	// 				alignment: {
	// 					wrapText: true,
	// 					vertical: "center",
	// 				},
	// 				font: {
	// 					size: 12,
	// 					bold: true,
	// 				}
	// 			}];
	// 			let qs = program.profile_config.questions;
	// 			let strengthScores = {};
	// 			let rankedList = [];
	// 			for (let i = 0; i < p.responses.length; i++) {
	// 				if (!strengthScores[qs[i].strength_id]) {
	// 					strengthScores[qs[i].strength_id] = []
	// 				}
	// 				strengthScores[qs[i].strength_id].push(p.responses[i].score / qs[i].max)
	// 			}
	// 			for (let i = 0; i < sortedStrengths.length; i++) {
	// 				let mean = 0.0
	// 				_.each(strengthScores[sortedStrengths[i].id], score => {
	// 					mean += score
	// 				})
	// 				rankedList.push({
	// 					"idx": i,
	// 					"name": sortedStrengths[i].name,
	// 					"score": mean / strengthScores[sortedStrengths[i].id].length
	// 				})
	// 			}
	// 			rankedList = _.orderBy(rankedList, "name")
	// 			rankedList = _.orderBy(rankedList, "score", "desc")
	// 			for (let i = 0; i < Math.min(5, rankedList.length); i++) {
	// 				row[rankedList[i].idx + 1] = (i + 1).toString();
	// 				let color = _.find(categories, { id: sortedStrengths[rankedList[i].idx].category_id }).color
	// 				row_styles[rankedList[i].idx + 1] = {
	// 					fill: {
	// 						type: "pattern",
	// 						patternType: "solid",
	// 						bgColor: color,
	// 						fgColor: color,
	// 					},
	// 					alignment: {
	// 						horizontal: "center",
	// 					}
	// 				};
	// 			}
	// 			table.rows.push(row);
	// 			table.styles.push(row_styles);
	// 		});
	// 		tables.push(table)
	// 	});

	// 	this.exportXLSX(tables, filenameFields);
	// },

	reduceHex(n, level) {
		let newNum = Math.floor(parseInt(n, 16) * 0.9 ** level).toString(16);
		while (newNum.length < 2) {
			newNum = '0' + newNum;
		}
		return newNum
	},

	dimColor(color, level) {
		let red = this.reduceHex(color.slice(1, 3), level);
		let green = this.reduceHex(color.slice(3, 5), level);
		let blue = this.reduceHex(color.slice(5, 7), level);

		return '#' + red + green + blue;
	},

	exportCanvases(canvases, config, student_name, section_name) {
		let filenameFields = [
			"Canvases",
			student_name
		];
		if (section_name) {
			filenameFields.push(section_name)
		}
		filenameFields.push(moment().format("M.D.YY-H.mm.ss"))

		let headers = [
			"Assignment",
			"Team",
			"Problem Statement",
			config.partners_title,
			config.activities_title,
			config.resources_title,
			config.value_title,
			config.relationships_title,
			config.channels_title,
			config.segments_title,
			config.discovery_title,
			config.cost_title,
			config.revenue_title,
		];

		let rows = [headers]

		_.each(canvases, canvas => {
			let row = [
				canvas.assignment.name,
				canvas.team.name,
				canvas.responses.problem,
				canvas.responses.partners,
				canvas.responses.activities,
				canvas.responses.resources,
				canvas.responses.values,
				canvas.responses.relationships,
				canvas.responses.channels,
				canvas.responses.segments,
				canvas.responses.discovery,
				canvas.responses.cost,
				canvas.responses.revenue
			];
			rows.push(row);
		});

		console.log(rows);

		this.exportCSV(rows, filenameFields);
	},

	exportCanvasMasterFile(canvases, config, label, show_submitted) {
		let filenameFields = [
			"Canvases",
			label,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Teacher Last Name",
			"Teacher First Name",
		]

		var num_teachers = 0;
		_.each(canvases, (c) => {
			if (c.section.teachers) {
				num_teachers = Math.max(num_teachers, c.section.teachers.length)
			}
		})
		for (var i = 1; i < num_teachers; i++) {
			headers = headers.concat([
				`Teacher ${i + 1} Last Name`,
				`Teacher ${i + 1} First Name`,
			])
		}

		headers = headers.concat([
			"District",
			"Class",
			"Assignment",
			"Team",
			"Problem Statement",
			config.partners_title,
			config.activities_title,
			config.resources_title,
			config.value_title,
			config.relationships_title,
			config.channels_title,
			config.segments_title,
			config.discovery_title,
			config.cost_title,
			config.revenue_title,
		]);

		if (show_submitted) {
			headers.push("Submitted?")
		}

		let rows = [headers]

		_.each(canvases, canvas => {
			let row = [];
			for (var i = 0; i < num_teachers; i++) {
				if (canvas.section.teachers && canvas.section.teachers.length > i) {
					row.push(canvas.section.teachers[i].name.last)
					row.push(canvas.section.teachers[i].name.first)
				} else {
					row = row.concat(['', ''])
				}
			}
			row = row.concat([
				canvas.district.name,
				canvas.section.name,
				canvas.assignment.name,
				canvas.team.name,
				canvas.responses.problem,
				canvas.responses.partners,
				canvas.responses.activities,
				canvas.responses.resources,
				canvas.responses.values,
				canvas.responses.relationships,
				canvas.responses.channels,
				canvas.responses.segments,
				canvas.responses.discovery,
				canvas.responses.cost,
				canvas.responses.revenue
			]);

			if (show_submitted) {
				row.push(canvas.submitted)
			}
			rows.push(row);
		});

		console.log(rows);

		this.exportCSV(rows, filenameFields);
	},

	exportProfiles(profiles, questions, student_name, section_name) {
		let filenameFields = [
			"Profiles",
			student_name,
			section_name,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Assignment",
			"Timestamp",
			"Question",
			"Score",
			"Reasoning"
		];

		let rows = [headers];

		_.each(profiles, p => {
			for (let i = 0; i < questions.length; i++) {
				rows.push([p.assignment.name, p.updated_at, questions[i].text, p.responses[i].score, p.responses[i].reasoning])
			}
		})

		this.exportCSV(rows, filenameFields);
	},

	exportProfileMasterFile(profile_data, label, show_submitted) {
		let filenameFields = [
			"Profiles",
			label,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Teacher Last Name",
			"Teacher First Name",
		];

		var num_teachers = 0;
		_.each(profile_data, (data) => {
			_.each(data.profiles, (p) => {
				if (p.section.teachers) {
					num_teachers = Math.max(num_teachers, p.section.teachers.length)
				}
			})
		})
		for (var i = 1; i < num_teachers; i++) {
			headers = headers.concat([
				`Teacher ${i + 1} Last Name`,
				`Teacher ${i + 1} First Name`,
			])
		}

		headers = headers.concat([
			"District",
			"Class",
			"Student",
			"Assignment",
			"Timestamp",
			"Question",
			"Score",
			"Reasoning",
			"Total Score",
		]);

		if (show_submitted) {
			headers.push("Submitted?")
		}

		let rows = [headers];

		_.each(profile_data, data => {
			var profiles = data['profiles'];
			var questions = data['questions'];
			_.each(profiles, p => {
				var max_score = 0.0;
				console.log(p)
				console.log(questions)
				for (let i = 0; i < questions.length; i++) {
					max_score += p.responses[i].score;
				}
				for (let i = 0; i < questions.length; i++) {
					let row = [];
					for (var j = 0; j < num_teachers; j++) {
						if (p.section.teachers && p.section.teachers.length > j) {
							row.push(p.section.teachers[j].name.last);
							row.push(p.section.teachers[j].name.first);
						} else {
							row = row.concat(['', '']);
						}
					}
					row = row.concat([
						p.district.name,
						p.section.name,
						fs.displayName(p.user.name),
						p.assignment.name,
						p.updated_at,
						questions[i].text,
						p.responses[i].score,
						p.responses[i].reasoning,
						max_score])
					if (show_submitted) {
						row.push(p.submitted)
					}
					rows.push(row);
				}
			});
		});

		this.exportCSV(rows, filenameFields);
	},
	exportTVRFeedback(feedbacks, section, categories, showReviewer) {
		console.log("feedbacks", feedbacks, "section", section);
		let filenameFields = [
			"TVRFeedback",
			section.name,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Timestamp",
			"Student",
			"Assignment",
		];

		if (showReviewer) {
			headers.push("Reviewer")
		}

		let catIdx = {};

		_.each(categories, c => {
			catIdx[c.id] = headers.length;
			headers.push(c.name + ' Score');
			headers.push(c.name + ' Explanation');
		});

		let rows = [headers];

		_.each(feedbacks, feedback => {
			console.log("FEEDBACK", feedback)
			let row = [feedback.updated_at, fs.displayName(feedback.recipient.name), feedback.assignment.name];
			if (showReviewer) {
				row.push(fs.displayName(feedback.provider.name))
			}
			_.each(feedback.response.responses, resp => {
				row[catIdx[resp.category_id]] = resp.score;
				row[catIdx[resp.category_id] + 1] = resp.text;
			})
			rows.push(row);
		})

		this.exportCSV(rows, filenameFields);
	},

	exportTVRFeedbackMasterFile(feedbacks, label, categories, showReviewer, show_submitted) {
		let filenameFields = [
			"TVRFeedback",
			label,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Teacher Last Name",
			"Teacher First Name",
		];

		var num_teachers = 0;
		_.each(feedbacks, (f) => {
			if (f.section.teachers) {
				num_teachers = Math.max(num_teachers, f.section.teachers.length)
			}
		})
		for (var i = 1; i < num_teachers; i++) {
			headers = headers.concat([
				`Teacher ${i + 1} Last Name`,
				`Teacher ${i + 1} First Name`,
			])
		}

		headers = headers.concat([
			"District",
			"Class",
			"Timestamp",
			"Student",
			"Assignment",
		]);

		if (showReviewer) {
			headers.push("Reviewer")
		}

		let catIdx = {};

		_.each(categories, c => {
			catIdx[c.id] = headers.length;
			headers.push(c.name + ' Score');
			headers.push(c.name + ' Explanation');
		});

		headers.push("Total")
		if (show_submitted) {
			headers.push("Submitted?")
		}

		let rows = [headers];

		_.each(feedbacks, feedback => {
			let total = 0.0;
			let row = [];
			for (var i = 0; i < num_teachers; i++) {
				if (feedback.section.teachers && feedback.section.teachers.length > i) {
					row.push(feedback.section.teachers[i].name.last)
					row.push(feedback.section.teachers[i].name.first)
				} else {
					row = row.concat(['', ''])
				}
			}
			row = row.concat([feedback.district.name, feedback.section.name, feedback.updated_at, fs.displayName(feedback.recipient.name), feedback.assignment.name]);
			if (showReviewer) {
				row.push(fs.displayName(feedback.provider.name))
			}
			_.each(feedback.response.responses, resp => {
				row[catIdx[resp.category_id]] = resp.score;
				row[catIdx[resp.category_id] + 1] = resp.text;
				total += resp.score;
			})
			row.push(total);
			if (show_submitted) {
				row.push(feedback.submitted);
			}
			rows.push(row);
		})

		this.exportCSV(rows, filenameFields);
	},

	exportPitchFeedback(feedbacks, section, categories, show_reviewer, show_average) {
		console.log("feedbacks", feedbacks, "section", section);
		let filenameFields = [
			"FeedbackReport",
			section.name,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Timestamp",
			"Team",
			"Assignment",
			"Reviewer Role",
		];

		if (show_reviewer) {
			headers.push("Reviewer Name")
		}

		let catIdx = {};

		if (categories.length) {
			_.each(categories, c => {
				catIdx[c.name] = headers.length;
				headers.push(c.name + ' Score');
				headers.push(c.name + ' Explanation');
			});
			headers.push("Total");
		}

		for (var feedback of feedbacks) {
			if (feedback.response.feedback) {
				headers.push("Feedback");
				break
			}
		}

		if (show_average) {
			headers.push("Team Average");
		}

		let rows = [headers];

		var team_totals = {};

		_.each(feedbacks, feedback => {
			let row = [];
			if (feedback.team) {
				row = [feedback.updated_at, feedback.team.name, feedback.assignment.name, feedback.user ? feedback.user.role : "UNKNOWN"]
			}
			else {
				row = [feedback.updated_at, feedback.team_id, feedback.assignment.name, feedback.user ? feedback.user.role : "UNKNOWN"]
			}
			if (show_reviewer) {
				if (feedback.user) {
					row.push(fs.displayName(feedback.user.name))
				} else {
					row.push("UNKNOWN")
				}
			}

			var total_score = 0.0;
			_.each(feedback.response.responses, resp => {
				if (resp.category) {
					row[catIdx[resp.category.name]] = resp.score;
					row[catIdx[resp.category.name] + 1] = resp.text;
				}
				total_score += resp.score;
			})

			if (categories.length) {
				row.push(total_score);
			}

			if (team_totals[row[1]]) {
				team_totals[row[1]].push(total_score);
			} else {
				team_totals[row[1]] = [total_score];
			}

			if (feedback.response.feedback != "") {
				row.push(feedback.response.feedback)
			}

			rows.push(row);
		})

		if (show_average) {
			for (var row of rows.slice(1)) {
				console.log(team_totals);
				console.log(row[1]);
				var vals = team_totals[row[1]];
				var mean = 0.0;
				for (var val of vals) {
					mean += val;
				}
				mean /= vals.length;
				row.push(mean);
			}
		}

		this.exportCSV(rows, filenameFields);
	},

	exportPitchFeedbackMasterFile(feedbacks, label, categories, show_reviewer, show_submitted) {
		let filenameFields = [
			"FeedbackReport",
			label,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Teacher Last Name",
			"Teacher First Name",
		]

		var num_teachers = 0;
		_.each(feedbacks, (f) => {
			if (f.section.teachers) {
				num_teachers = Math.max(num_teachers, f.section.teachers.length)
			}
		})
		for (var i = 1; i < num_teachers; i++) {
			headers = headers.concat([
				`Teacher ${i + 1} Last Name`,
				`Teacher ${i + 1} First Name`,
			])
		}

		headers = headers.concat([
			"District",
			"Class",
			"Timestamp",
			"Team",
			"Assignment",
			"Reviewer Role",
		]);

		if (show_reviewer) {
			headers.push("Reviewer Name")
		}

		let catIdx = {};

		_.each(categories, c => {
			catIdx[c.name] = headers.length;
			headers.push(c.name + ' Score');
			headers.push(c.name + ' Explanation');
		});

		headers.push("Total");
		if (show_submitted) {
			headers.push("Submitted?")
		}
		headers.push("Team Average");

		let rows = [headers];

		var team_totals = {};

		_.each(feedbacks, feedback => {
			let row = [];
			for (var i = 0; i < num_teachers; i++) {
				if (feedback.section.teachers && feedback.section.teachers.length > i) {
					row.push(feedback.section.teachers[i].name.last)
					row.push(feedback.section.teachers[i].name.first)
				} else {
					row = row.concat(['', ''])
				}
			}
			row = row.concat([feedback.district.name, feedback.section.name]);
			if (feedback.team) {
				row = row.concat([feedback.updated_at, feedback.team.name, feedback.assignment.name, feedback.user ? feedback.user.role : "UNKNOWN"]);
			}
			else {
				row = row.concat([feedback.updated_at, feedback.team_id, feedback.assignment.name, feedback.user ? feedback.user.role : "UNKNOWN"]);
			}
			if (show_reviewer) {
				if (feedback.user) {
					row.push(fs.displayName(feedback.user.name))
				} else {
					row.push("UNKNOWN")
				}
			}

			var total_score = 0.0;
			_.each(feedback.response.responses, resp => {
				row[catIdx[resp.category.name]] = resp.score;
				row[catIdx[resp.category.name] + 1] = resp.text;
				total_score += resp.score;
			})

			row.push(total_score);

			if (team_totals[row[5]]) {
				team_totals[row[5]].push(total_score);
			} else {
				team_totals[row[5]] = [total_score];
			}

			if (show_submitted) {
				row.push(feedback.submitted)
			}

			rows.push(row);
		})

		for (var row of rows.slice(1)) {
			var vals = team_totals[row[5]];
			var mean = 0.0;
			for (var val of vals) {
				mean += val;
			}
			mean /= vals.length;
			row.push(mean);
		}

		this.exportCSV(rows, filenameFields);
	},

	exportPitchScores(feedbacks, section, categories) {
		console.log("feedbacks", feedbacks, "section", section, "categories", categories);

		let filenameFields = [
			"PitchScoreReport",
			section.name,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Team",
			"Assignment"
		];

		_.each(categories, c => {
			headers.push(c.name);
		});

		headers.push("Total");

		let rows = [headers];


		let avgArr = function (arr) {
			return arr.reduce((a, b) => a + b, 0) / arr.length
		}

		_.each(feedbacks, feedback => {
			let row = [feedback.team, feedback.assignment];
			let all_scores = [];
			_.each(categories, c => {
				all_scores = all_scores.concat(feedback.scores[c.name]);
				row.push(avgArr(feedback.scores[c.name]));
			});
			row.push(avgArr(all_scores));
			rows.push(row);
		});

		this.exportCSV(rows, filenameFields);
	},

	exportProfileScores(section, program, assignments, profiles, students) {
		console.log("section", section, "program", program, "assignments", assignments, "profile", profiles, "students", students)
		let filenameFields = [
			"ProfileRpt",
			section.name,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Assignment",
			"Student",
			"Time",
		]
		_.each(program.profile_config.questions, (q, i) => {
			let strength = _.find(program.profile_config.strengths, { id: q.strength_id })
			if (strength) {
				headers.push(strength.name)
				headers.push(strength.name + " Reasoning")
			} else {
				headers.push(`Question ${i + 1}`)
				headers.push(`Question ${i + 1} Reasoning`)
			}
		})
		let rows = [headers];

		_.each(assignments, a => {
			let assignmentProfiles = _.filter(profiles, { assignment_id: a.id })
			_.each(assignmentProfiles, p => {
				let row = [a.name]

				let student = _.find(students, { id: p.user_id })
				if (student) {
					row.push(fs.displayNameReverse(student.name))
				} else {
					row.push("(Not found in class)")
				}

				row.push(p.created_at)
				_.each(program.profile_config.questions, q => {
					let response = _.find(p.responses, { item_id: q.id })
					if (response) {
						row.push(response.score)
						row.push(response.reasoning)
					} else {
						row.push("")
						row.push("")
					}
				})

				rows.push(row)
			})
		})

		this.exportCSV(rows, filenameFields);
	},

	exportProfileRankings(section, program, assignments, profiles, students) {
		console.log("section", section, "program", program, "assignments", assignments, "profile", profiles, "students", students)
		let filenameFields = [
			"ProfileRpt",
			section.name,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Assignment",
			"Student",
			"Time",
		]
		_.each(program.profile_config.questions, (_, i) => {
			headers.push(`Rank ${i + 1}`)
		})
		let rows = [headers];

		_.each(assignments, a => {
			let assignmentProfiles = _.filter(profiles, { assignment_id: a.id })
			_.each(assignmentProfiles, p => {
				let row = [a.name]

				let student = _.find(students, { id: p.user_id })
				if (student) {
					row.push(fs.displayNameReverse(student.name))
				} else {
					row.push("(Not found in class)")
				}

				row.push(p.created_at)

				let scores = []
				_.each(program.profile_config.questions, (q, i) => {
					let response = _.find(p.responses, { item_id: q.id })
					let name = ""
					let strength = _.find(program.profile_config.strengths, { id: q.strength_id })
					if (strength) {
						name = strength.name
					} else {
						name = `Question ${i + 1}`
					}

					if (response) {
						scores.push({ score: response.score, name: name })
					} else {
						scores.push({ score: -1, name: name })
					}
				})
				scores = _.orderBy(scores, "name")
				scores = _.orderBy(scores, "score", "desc")
				_.each(scores, s => {
					row.push(s.name)
				})

				rows.push(row)
			})
		})

		this.exportCSV(rows, filenameFields);
	},

	exportProfileRankingsStudent(section, program, assignments, profiles) {
		console.log("section", section, "program", program, "assignments", assignments, "profiles", profiles)
		let filenameFields = [
			"ProfileRpt",
			section.name,
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [
			"Rank"
		]
		_.each(profiles, p => {
			p.assignment = _.find(assignments, { id: p.assignment_id });
			if (p.assignment) {
				headers.push(p.assignment.name);
			}
		});
		profiles = profiles.filter(p => p.assignment);

		let rows = [headers];

		let all_scores = {}
		_.each(profiles, p => {
			let scores = [];
			_.each(program.profile_config.questions, (q, i) => {
				let response = _.find(p.responses, { item_id: q.id })
				let name = ""
				let strength = _.find(program.profile_config.strengths, { id: q.strength_id })
				if (strength) {
					name = strength.name;
					//name = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
				} else {
					name = `Question ${i + 1}`
				}

				if (response) {
					scores.push({ score: response.score, name: name })
				} else {
					scores.push({ score: -1, name: name })
				}
			})
			scores = _.orderBy(scores, "score", "desc")
			all_scores[p.id] = scores
		})


		_.each(program.profile_config.questions, (q, i) => {
			let row = [`Rank ${i + 1}`]
			_.each(profiles, p => {
				row.push(all_scores[p.id][i].name)
			});
			rows.push(row);
		})

		this.exportCSV(rows, filenameFields);
	},

	exportUsers(users, districts) {
		console.log("users", users, "districts", districts)
		let filenameFields = [
			"StemInn",
			"Users",
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = ["First Name", "Last Name", "District", "Email", "Role", "Created", "Disabled"]
		let rows = [headers]

		_.each(users, u => {
			let row = []

			let districtName = ""
			let district = _.find(districts, { id: u.district_id })
			if (district) {
				districtName = district.name
			}

			row.push(u.name.first)
			row.push(u.name.last)
			row.push(districtName)
			row.push(u.email)
			row.push(fs.roleName(u.role))
			row.push(u.created)
			row.push(u.disabled)

			rows.push(row)
		})

		this.exportCSV(rows, filenameFields);
	},

	exportSchools(schools, districts) {
		let filenameFields = [
			"StemInn",
			"Schools",
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = ["Name", "District"]
		let rows = [headers]

		_.each(schools, s => {
			let row = []

			let districtName = ""
			let district = _.find(districts, { id: s.district_id })
			if (district) {
				districtName = district.name
			}

			row.push(s.name)
			row.push(districtName)

			rows.push(row)
		})

		this.exportCSV(rows, filenameFields);
	},

	exportSections(sections, districts) {
		let filenameFields = [
			"StemInn",
			"Sections",
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = ["Name", "District"]
		let rows = [headers]

		_.each(sections, s => {
			let row = []

			let districtName = ""
			let district = _.find(districts, { id: s.district_id })
			if (district) {
				districtName = district.name
			}

			row.push(s.name)
			row.push(districtName)

			rows.push(row)
		})

		this.exportCSV(rows, filenameFields);
	},

	exportDistricts(districts, data) {
		let filenameFields = [
			"StemInn",
			"Districts",
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = ["Name", "Enabled", "Programs", "Schools", "Classes", "Teachers", "Students", "Partners"]
		let rows = [headers]

		_.each(districts, d => {
			let row = []

			row.push(d.name)
			row.push(d.enabled ? 1 : 0)
			row.push(d.program_ids.length)

			for (let key of ["schools", "sections", "teachers", "students", "partners"]) {
				let count_obj = _.find(data[key], { _id: d.id })
				if (count_obj && count_obj.count) {
					row.push(count_obj.count)
				}
				else {
					row.push(0)
				}
			}

			rows.push(row)
		})

		this.exportCSV(rows, filenameFields);
	},

	exportActivity(entities, entityName, data) {
		let filenameFields = [
			"StemInn",
			"Activity",
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = [entityName, "Profiles", "Pitches", "TVRs", "Canvases"]
		let rows = [headers]

		_.each(entities, d => {
			let row = []

			row.push(d.name)
			for (let key of ["profiles", "pitches", "tvrs", "canvases"]) {
				let count_obj = _.find(data[key], { _id: d.id })
				if (count_obj && count_obj.count) {
					row.push(count_obj.count)
				}
				else {
					row.push(0)
				}
			}

			rows.push(row)
		})

		this.exportCSV(rows, filenameFields)
	},

	exportPrograms(programs) {
		let filenameFields = [
			"StemInn",
			"Programs",
			moment().format("M.D.YY-H.mm.ss")
		];

		let headers = ["Name", "Profile Questions", "Pitch Categories", "Team Value Rubric Categories", "Contest Pitch Categories"]
		let rows = [headers]

		_.each(programs, p => {
			let row = []

			row.push(p.name)
			row.push(p.profile_config.questions.length)
			row.push(p.pitch_config.rubric.categories.length)
			row.push(p.tvr_config.rubric.categories.length)
			row.push(p.contest_config.rubric.categories.length)

			rows.push(row)
		})

		this.exportCSV(rows, filenameFields);
	},

	exportCSV(rows, filenameFields) {
		var processRow = function (row) {
			var finalVal = "";
			for (var j = 0; j < row.length; j++) {
				var innerValue = row[j] === null ? "" : row[j].toString();
				if (row[j] instanceof Date) {
					innerValue = row[j].toLocaleString();
				}
				var result = innerValue.replace(/"/g, '""'); //Escape single quotes
				if (result.search(/("|,|\n)/g) >= 0)
					//Escape other problematic characters
					result = '"' + result + '"';
				if (j > 0) finalVal += ",";
				finalVal += result;
			}
			return finalVal + "\n";
		};

		var processFileName = function (filenameFields) {
			var filename = "";
			for (var i = 0; i < filenameFields.length; i++) {
				var field = filenameFields[i];
				field = field.replace(/\s/g, "_"); //Replace white space with dashes
				field = field.replace(/<|>|\/|\\|:|"|\||\?|\*/g, "#"); //Replace forbidden characters with pound signs 'cause why not

				filename = filename + (i > 0 ? " " : "") + field;
			}

			return filename + ".csv";
		};

		//var csvFile = "sep=,\n";
		var csvFile = "";
		for (var i = 0; i < rows.length; i++) {
			csvFile += processRow(rows[i]);
		}

		var blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
		if (navigator.msSaveBlob) {
			// IE 10+
			navigator.msSaveBlob(blob, processFileName(filenameFields));
		} else {
			var link = document.createElement("a");
			if (link.download !== undefined) {
				// feature detection
				// Browsers that support HTML5 download attribute
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", processFileName(filenameFields));
				link.style.visibility = "hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	},

	// exportXLSX(tables, filenameFields) {
	// 	var processTable = function (wb, table) {
	// 		let ws = wb.addWorksheet(table.name, {
	// 			'sheetFormat': {
	// 				'defaultColWidth': 10,
	// 			}
	// 		});

	// 		let headingSize = 0;
	// 		_.each(table.heading, (h) => {
	// 			if (h.cells[2] > headingSize) {
	// 				headingSize = h.cells[2]
	// 			}
	// 			ws.cell(h.cells[0], h.cells[1], h.cells[2], h.cells[3], true)
	// 				.string(h.content)
	// 				.style(wb.createStyle(h.style))
	// 		});

	// 		ws.row(2).setHeight(134);

	// 		for (let i = 0; i < table.rows.length; i++) {
	// 			for (let j = 0; j < table.rows[i].length; j++) {
	// 				if (table.rows[i][j] && table.styles[i][j]) {
	// 					ws.cell(i + headingSize + 1, j + 1)
	// 						.string(table.rows[i][j])
	// 						.style(wb.createStyle(table.styles[i][j]));
	// 				}
	// 			}
	// 		}
	// 		ws.column(1).setWidth(20);
	// 		return wb;
	// 	}

	// 	var processFileName = function (filenameFields) {
	// 		var filename = "";
	// 		for (var i = 0; i < filenameFields.length; i++) {
	// 			var field = filenameFields[i];
	// 			field = field.replace(/\s/g, "_"); //Replace white space with dashes
	// 			field = field.replace(/<|>|\/|\\|:|"|\||\?|\*/g, "#"); //Replace forbidden characters with pound signs 'cause why not

	// 			filename = filename + (i > 0 ? " " : "") + field;
	// 		}

	// 		return filename + ".xlsx";
	// 	};

	// 	let wb = new xl.Workbook();
	// 	_.each(tables, (table) => {
	// 		wb = processTable(wb, table);
	// 	});

	// 	wb.writeToBuffer().then((buf) => {
	// 		var blob = new Blob([buf], { type: "application/octet-stream" });
	// 		if (navigator.msSaveBlob) {
	// 			// IE 10+
	// 			navigator.msSaveBlob(blob, processFileName(filenameFields));
	// 		} else {
	// 			var link = document.createElement("a");
	// 			if (link.download !== undefined) {
	// 				// feature detection
	// 				// Browsers that support HTML5 download attribute
	// 				var url = URL.createObjectURL(blob);
	// 				link.setAttribute("href", url);
	// 				link.setAttribute("download", processFileName(filenameFields));
	// 				link.style.visibility = "hidden";
	// 				document.body.appendChild(link);
	// 				link.click();
	// 				document.body.removeChild(link);
	// 			}
	// 		}

	// 	})
	// },

	CSVToArray(strData, strDelimiter) {
		// Check to see if the delimiter is defined. If not,
		// then default to comma.
		strDelimiter = strDelimiter || ",";
		// Create a regular expression to parse the CSV values.
		var objPattern = new RegExp(
			// Delimiters.
			"(\\" +
			strDelimiter +
			"|\\r?\\n|\\r|^)" +
			// Quoted fields.
			'(?:"([^"]*(?:""[^"]*)*)"|' +
			// Standard fields.
			'([^"\\' +
			strDelimiter +
			"\\r\\n]*))",
			"gi"
		);
		// Create an array to hold our data. Give the array
		// a default empty first row.
		var arrData = [[]];
		// Create an array to hold our individual pattern
		// matching groups.
		var arrMatches = null;
		// Keep looping over the regular expression matches
		// until we can no longer find a match.
		while ((arrMatches = objPattern.exec(strData))) {
			// Get the delimiter that was found.
			var strMatchedDelimiter = arrMatches[1];
			// Check to see if the given delimiter has a length
			// (is not the start of string) and if it matches
			// field delimiter. If id does not, then we know
			// that this delimiter is a row delimiter.
			if (
				strMatchedDelimiter.length &&
				strMatchedDelimiter != strDelimiter
			) {
				// Since we have reached a new row of data,
				// add an empty row to our data array.
				arrData.push([]);
			}
			// Now that we have our delimiter out of the way,
			// let's check to see which kind of value we
			// captured (quoted or unquoted).
			let strMatchedValue = ""
			if (arrMatches[2]) {
				// We found a quoted value. When we capture
				// this value, unescape any double quotes.
				strMatchedValue = arrMatches[2].replace(
					new RegExp('""', "g"),
					'"'
				);
			} else {
				// We found a non-quoted value.
				strMatchedValue = arrMatches[3];
			}
			// Now that we have our value string, let's add
			// it to the data array.
			arrData[arrData.length - 1].push(strMatchedValue);
		}
		// Return the parsed data.
		return arrData;
	},
};
